module.exports = __webpack_public_path__ + "static/commerce2x-commerce-four-00ee3b25f9089c5e4cca37e9b921e380.jpg";